import { jsx as o } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as f, useCallback as c } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { TX_DATA_CONTAINER as d, TX_DATA_INPUT_HEAD as T, TX_DATA_INPUT_CONTAINER as u, TX_DATA_INPUT_CONTAINER_SHORT as p } from "../constants.js";
import { REFUND_REASONS as R } from "../../context/constants.js";
import N from "../../../../../core/Context/useCoreContext.js";
import A from "../../../../internal/Typography/Typography.js";
import { TypographyElement as _, TypographyVariant as h } from "../../../../internal/Typography/types.js";
import { useTransactionRefundContext as g } from "../../context/refund/context.js";
import C from "../../../../internal/FormFields/Select/Select.js";
const P = () => {
  const { i18n: n } = N(), { interactionsDisabled: s, refundReason: i, setRefundReason: r } = g(), m = f(
    () => Object.freeze(
      R.map((e) => ({ id: e, name: n.has(`refundReason.${e}`) ? n.get(`refundReason.${e}`) : e }))
    ),
    [n]
  ), l = c(
    (e) => {
      var t;
      const a = (t = e.target) == null ? void 0 : t.value;
      a && r(a);
    },
    [r]
  );
  return /* @__PURE__ */ o("div", { className: d, children: [
    /* @__PURE__ */ o("div", { className: T, children: /* @__PURE__ */ o(A, { el: _.SPAN, variant: h.BODY, stronger: !0, children: n.get("refundReason") }) }),
    /* @__PURE__ */ o("div", { className: `${u} ${p}`, children: /* @__PURE__ */ o(
      C,
      {
        items: m,
        readonly: s,
        filterable: !1,
        multiSelect: !1,
        onChange: l,
        selected: i
      }
    ) })
  ] });
};
export {
  P as default
};
